var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.05 0.95H15.2V0H3.8V0.95H0.95C0.38 0.95 0 1.33 0 1.9V4.18C0 6.365 1.615 8.17 3.8 8.455V8.55C3.8 11.305 5.7 13.585 8.265 14.155L7.6 16.15H5.415C5.035 16.15 4.655 16.435 4.56 16.815L3.8 19H15.2L14.44 16.815C14.345 16.435 13.965 16.15 13.585 16.15H11.4L10.735 14.155C13.3 13.585 15.2 11.305 15.2 8.55V8.455C17.385 8.17 19 6.365 19 4.18V1.9C19 1.33 18.62 0.95 18.05 0.95ZM3.8 6.555C2.755 6.27 1.9 5.32 1.9 4.18V2.85H3.8V6.555ZM11.4 9.5L9.5 8.455L7.6 9.5L8.075 7.6L6.65 5.7H8.645L9.5 3.8L10.355 5.7H12.35L10.925 7.6L11.4 9.5ZM17.1 4.18C17.1 5.32 16.245 6.365 15.2 6.555V2.85H17.1V4.18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.0c9eddb202a1e6a0f4d857c62b9c4258.svg";
export { ForwardRef as ReactComponent };